<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-main>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper pl-2">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="white pa-3 app--footer">
              <span class="caption">phanmemdathangoee.com Design &copy; {{ new Date().getFullYear() }}</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-main>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-snackbar :timeout="snackbar.timeout ? snackbar.timeout : 30000" :color="snackbar.color" v-model="snackbar.show" top multi-line>
            <p class="mt-4 body-1">{{ snackbar.text }}<v-btn class="pl-4" dark text @click.native="snackbar.show = false" icon>
              <v-icon>close</v-icon>
            </v-btn></p>
          </v-snackbar>
          <v-dialog v-model="delDialog" max-width="500px">
            <v-card>
              <v-card-title><h3>Xác nhận</h3></v-card-title>
              <v-card-text>
                <p>{{ delMessage || 'Bạn có chắc chắn muốn xóa mục đã chọn?'}}</p>
                <p v-if="!delMessage" class="red--text">
                  Lưu ý: Thao tác xóa không thể khôi phục, vui lòng kiểm tra trước khi thao tác.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="delDialog = false">Hủy</v-btn>
                <v-btn color="red darken-1" dark @click="delConfirmed">Đồng ý</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    delMessage: "",
    delDialog: false,
    delId: 0,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  computed: {
    ...mapState("commons", {
      sidebarExpanded: "sidebarExpanded"
    })
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      if (this.confirmAction == 'REQUEST_BULK_DELETE') {
        this.$store.dispatch("commons/bulk_delete", {
          ids: this.delIds,
          obj_type: this.obj_type
        });
      }
      else if (this.confirmAction != '') {
        this.$root.$emit('CONFIRMED_ACTION', {action: this.confirmAction, id: this.delId});
      }
      else {
        this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
      }
      this.delId = 0;
      this.confirmAction = "";
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.$store.commit("commons/setSidebarExpanded", {
        expanded: !this.sidebarExpanded
      });
    });
  },
  mounted() {
    if(this.$store.state.authentication.token != "") {
      this.$store.dispatch("roles/getList");
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 230px;
}

.v-snack__wrapper p {
  margin: 0 0 0 0 !important;
}
</style>
